import React, {useState, useEffect, useContext} from 'react';
import Modal from "react-modal";
import { Bars } from "react-loader-spinner";

import {UserContext} from '../../utils/userDetailsProvider';


import styled from "styled-components";
import {
    useHistory,
} from "react-router-dom";

import { createUserDirectPerk } from '../../utils/perksUtils';
import CancelIcon from "../../assets/cancel_icon.svg";

const BidHeaderStyledSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const GlipHelpTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.4;
  display: block;
`

const ConfirmPurchaseButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: lawngreen;
  margin-top: 16px;
  cursor: pointer;
  border-radius: 12px;
`


const ButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;   
`

const UseLaterButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: green;
  margin-top: 16px;
  cursor: pointer;
  border-radius: 12px;
`



export default function ConfirmStreamPowerBuyModalComponent(props:any) {

    let modalWidth = "446px";
    let modalHeight = "220px";

    const userDetails = useContext(UserContext);
    const isMobile = userDetails.isMobile;
    
    if(isMobile){
        modalWidth = "320px";
    }
    
    const [loader, setIsLoader] = useState(true);
    const history = useHistory();

    console.log(props, 'propsmaxx');
    useEffect(()=>{
        setIsLoader(false);
    },[]);
    
    const handleUseClick = async () => {
        if(loader){
            return;
        }
        
        history.push({
            pathname: `/power/${props.userDirectPerk._id}`,
            state: {power:props.power}});

        setIsLoader(false);
        return;
    }
        
    return (
        <>
            <Modal
	        isOpen={props.isOpen}
	        style={{
	            content: {
		        background: "#0F0F0F",
		        width: modalWidth,
		        height: modalHeight,
		        marginLeft: "auto",
		        marginRight: "auto",
		        marginTop: "auto",
		        marginBottom: "auto",
		        border:"none",
	            }
	        }}
	    >
                <img onClick={()=>{props.handleModalCloseEvent()}}
                     src={CancelIcon}
	             style={{
		         position: "absolute", opacity: 0.4,
		         height: 14, width:14,
		         right:10, cursor:"pointer",
		         zIndex:10
	             }}
	        />
                <BidHeaderStyledSpan>
	            Stream Power Bought
	        </BidHeaderStyledSpan>
                <div>
                    <ConfirmPurchaseButtonDiv onClick={()=>{handleUseClick()} }>
                        {(loader) && (
                            <Bars height="30" width="30"
                                  color="grey"
                                  arialLabel="loading-indicator" />
                        )}
                        {(!loader) && (
                            <ButtonTextSpan>
                                Use Power
                            </ButtonTextSpan>
                        )}
                    </ConfirmPurchaseButtonDiv>
                    <UseLaterButtonDiv onClick={()=>{props.handleModalCloseEvent()}}>
                        <ButtonTextSpan>
                            Use Later
                        </ButtonTextSpan>
                    </UseLaterButtonDiv>
                </div>                
            </Modal>
        </>
    );
}
